import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function CancelModal({
    isOpen,
    onClose,
    onConfirm,
    appointmentId,
}) {

    const methods = useForm();
    const { control, formState: { errors }, handleSubmit } = methods;
    const [loader, setLoader] = useState(false);

    useEffect(() => {

        methods.reset({ cancel_reason: '' })

    }, [isOpen])



    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
                <form action="" onSubmit={handleSubmit((data) => {
                    setLoader(true);
                    onConfirm(data, "cancel", () => {
                        setLoader(false);
                    })
                })}>
                    <ModalHeader className='header_modal align-items-center'>
                        <h5 className="modal-title_u">Cancel Appointment</h5>
                    </ModalHeader>
                    <ModalBody className='modal_form_body'>
                        <div className='step_cards min-height-auto'>
                            <h2>Appointment ID: {appointmentId}</h2>
                            {/* Reason */}
                            <div className="row-primary">
                                <h2>Reason</h2>
                                <Controller
                                    name="cancel_reason"
                                    control={control}
                                    rules={{
                                        required: "Please write reason"
                                    }}
                                    render={({ field }) =>
                                        <>
                                            <textarea
                                                className="type_inp input-in"
                                                {...field}
                                                placeholder='Write reason for Cancel ...'
                                                required
                                            >
                                            </textarea>

                                            {errors?.cancel_reason?.message && (
                                                <ErrorMessage
                                                    text={errors?.cancel_reason?.message}
                                                />
                                            )}
                                        </>
                                    }

                                />
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <SubmitButton buttonType="submit" className={'tomatoRed'} btnText="Cancel" loader={loader} />
                        <button className="Cancle_button" type='button' onClick={onClose}>Close</button>
                    </ModalFooter>
                </form>
            </Modal>
        </>
    );
}

export default CancelModal;